module.exports = __webpack_public_path__ + "img/Mega.59111b1e.png";